import { QueryClient } from 'react-query';
import constants from '~/utils/constants';

// initialize `react-query` client with updated default options
const defaultOptions = constants.reactQueryClientOptions.default;
export const queryClient = new QueryClient({ defaultOptions });
